module.exports = __webpack_public_path__ + "static/media/Slider 2 4.30446533.jpg";